/* Canicross guide sign-up (/pages/canicross-nutrition). v1.0, 21 Oct 2026.
   1. Subscribes the email to the Canicross Guide list. Sets diet_type and next_race_date on the profile
      (these two always overwrite: latest answer wins).
   2. Tracks "Downloaded Canicross Guide" with every answer. The Klaviyo guide flow then fills dog_name and
      dog_activity only if they're empty, and adds the discipline to the dog_discipline list.
   Values match the locked lists on the Notion "Data capture and personalisation" page. Never add new ones here. */
(function () {
  var form = document.querySelector('[data-cn-form]');
  if (!form) return;

  var COMPANY = form.getAttribute('data-company');
  var LIST = form.getAttribute('data-list');
  var REVISION = '2024-10-15';
  var DIETS = ['raw', 'cold-pressed', 'dry', 'wet', 'home-cooked', 'mixed'];
  var SPORTS = ['canicross', 'bikejor', 'hiking', 'other'];

  var race = form.querySelector('[name="next_race_date"]');
  var noRace = form.querySelector('[data-cn-norace]');
  var btn = form.querySelector('[data-cn-submit]');

  // Race date can't be in the past
  var today = new Date();
  var iso = function (d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  race.min = iso(today);
  var max = new Date(today); max.setFullYear(max.getFullYear() + 2); race.max = iso(max);

  noRace.addEventListener('change', function () {
    race.disabled = noRace.checked;
    if (noRace.checked) { race.value = ''; showErr('next_race_date', false); }
  });

  function val(name) {
    var el = form.querySelector('[name="' + name + '"]:checked') || form.querySelector('[name="' + name + '"]:not([type="radio"])');
    return el ? String(el.value || '').trim() : '';
  }
  function showErr(key, on) {
    var e = form.querySelector('[data-err="' + key + '"]');
    if (e) e.classList.toggle('ft-hide', !on);
    var input = form.querySelector('[name="' + key + '"]');
    if (input && input.classList.contains('ft-in')) input.classList.toggle('is-bad', !!on);
  }
  // Clear an error as soon as it's fixed
  form.addEventListener('input', function (ev) { if (ev.target.name) showErr(ev.target.name, false); });
  form.addEventListener('change', function (ev) { if (ev.target.name) showErr(ev.target.name, false); });

  function utm() {
    var p = new URLSearchParams(window.location.search), out = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (p.get(k)) out[k] = p.get(k); });
    return out;
  }

  function send(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
      body: JSON.stringify({ data: body })
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); });
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    showErr('send', false);

    var email = val('email').toLowerCase();
    var dog = val('dog_name').replace(/\s+/g, ' ');
    var diet = val('diet_type');
    var sport = val('discipline');
    var date = noRace.checked ? '' : val('next_race_date');

    var bad = [];
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) bad.push('email');
    if (!dog) bad.push('dog_name');
    if (DIETS.indexOf(diet) === -1) bad.push('diet_type');
    if (SPORTS.indexOf(sport) === -1) bad.push('discipline');
    if (date && (date < race.min || date > race.max)) bad.push('next_race_date');
    ['email', 'dog_name', 'diet_type', 'discipline', 'next_race_date'].forEach(function (k) { showErr(k, bad.indexOf(k) > -1); });
    if (bad.length) {
      var first = form.querySelector('[data-err="' + bad[0] + '"]');
      if (first) first.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Sending…';

    // Overwriting properties only. Name and activity go in the event (filled by the flow only if empty).
    var props = { diet_type: diet };
    if (date) props.next_race_date = date;

    var answers = Object.assign({
      dog_name: dog,
      diet_type: diet,
      discipline: sport,
      next_race_date: date || null,
      no_race_booked: !date,
      dog_activity: 'sport',
      page: window.location.pathname,
      guide_version: 'v1'
    }, utm());

    send('subscriptions', {
      type: 'subscription',
      attributes: {
        custom_source: 'Canicross guide page',
        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
      },
      relationships: { list: { data: { type: 'list', id: LIST } } }
    })
    .then(function () {
      return send('events', {
        type: 'event',
        attributes: {
          properties: answers,
          metric: { data: { type: 'metric', attributes: { name: 'Downloaded Canicross Guide' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      });
    })
    .then(function () {
      // Let Klaviyo's on-site script know who this is, so later browsing is tied to the profile
      try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', { email: email }]); } catch (e) {}
      var done = form.querySelector('[data-cn-step="done"]');
      var txt = done.querySelector('[data-cn-done-text]');
      var t = txt.getAttribute('data-template');
      if (t) txt.textContent = t.split('[dog]').join(dog);
      var dogLink = done.querySelector('a.ft-btn');
      if (dogLink) dogLink.textContent = dogLink.textContent.split('[dog]').join(dog);
      form.querySelector('[data-cn-step="form"]').classList.add('ft-hide');
      done.classList.remove('ft-hide');
      done.focus();
      document.getElementById('get-guide').scrollIntoView({ behavior: 'smooth', block: 'center' });
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = label;
      showErr('send', true);
    });
  });
})();
